"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryService = void 0;
const history_1 = require("../models/history");
const types_1 = require("../models/ticket/types");
const api_1 = require("./api");
const GAME_PATH = 'game/api';
const LOYALTY_PATH = '/loyalty/api';
const LEGACY_PATH = '/legacy/api/history';
const LOYALTY_PATH_V2 = 'loyalty/api/v2';
const EINSTANT_PATH = 'einstant/api/v1/bet';
class HistoryService {
    static async getUserTicketEntriesHistory(size, page, sort, dateStart = '', dateEnd = '', withoutPattern = false) {
        let requestParams = { size };
        if (page) {
            requestParams = Object.assign(Object.assign({}, requestParams), { page });
        }
        if (sort) {
            requestParams = Object.assign(Object.assign({}, requestParams), { sort });
        }
        else {
            requestParams = Object.assign(Object.assign({}, requestParams), { sort: 'enteredTime,desc' });
        }
        if (!!dateStart && !!dateEnd) {
            requestParams = Object.assign(Object.assign({}, requestParams), { 'enteredTime.greaterThanOrEqual': dateStart, 'enteredTime.lessThanOrEqual': dateEnd });
        }
        const url = `${GAME_PATH}/ticket-entries/history`;
        try {
            const response = await api_1.API.get({
                url,
                query: requestParams
            });
            return {
                data: history_1.TicketEntryHistory.JsonToTickets(response.content, withoutPattern),
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getUserActivitiesHistory(pageNumber, pageSize) {
        try {
            const response = await api_1.API.get({
                url: `${LOYALTY_PATH}/user/user-activity/history`,
                query: {
                    pageSize,
                    pageNumber
                }
            });
            return this.activityResponse(pageSize, response);
        }
        catch (e) {
            throw e;
        }
    }
    static async filterUserActivitiesHistory(dateStart, dateEnd, paging = {}) {
        const query = Object.assign({ dateStart,
            dateEnd }, paging);
        const pageSize = paging && paging.pageSize ? paging.pageSize : 0;
        try {
            const response = await api_1.API.get({
                url: `${LOYALTY_PATH}/user/user-activity/history/filter`,
                query
            });
            return this.activityResponse(pageSize, response);
        }
        catch (e) {
            throw e;
        }
    }
    static activityResponse(pageSize, response) {
        if (response) {
            const data = history_1.HistoryActivity.JsonToActivities(response);
            return {
                content: data,
                lastPage: data.length === 0 || data.length < pageSize
            };
        }
        return {
            historyActivities: undefined,
            lastPage: undefined
        };
    }
    static async getUserRewardsHistoryV2(size, page, dateStart, dateEnd) {
        try {
            const response = await api_1.API.get({
                url: `${LOYALTY_PATH_V2}/rewards/history`,
                query: {
                    pageSize: size,
                    pageNumber: page + 1,
                    dateStart,
                    dateEnd
                }
            });
            if (response && response.redemptions) {
                const data = history_1.HistoryReward.JsonToRewards(response.redemptions);
                return {
                    historyRewards: data,
                    rewardsLastPage: data.length < size || response.paging.total <= size,
                    paging: response.paging
                };
            }
            return {
                historyRewards: undefined,
                rewardsLastPage: undefined
            };
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserRewardsHistory() {
        try {
            const response = await api_1.API.get({
                url: `${LOYALTY_PATH}/user/rewards/history`
            });
            return history_1.HistoryReward.JsonToRewards(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchDrawsByIds(ticket) {
        try {
            let ids = [];
            if (ticket && ticket.prizes && ticket.prizes.length) {
                ids = ticket.prizes.filter(t => t.prizeType === types_1.PrizeType.ENTRY).map(p => p.externalId);
            }
            if (ids.length > 0) {
                const requestParams = ids.join(',');
                const response = await api_1.API.get({
                    url: `${GAME_PATH}/draws-by-ids?ids=${requestParams}`
                });
                if (response) {
                    ticket.prizes.forEach(prize => {
                        const drawData = response.find((draw) => draw.id === Number(prize.externalId));
                        prize.drawName = drawData ? drawData.name : null;
                    });
                }
            }
            return ticket;
        }
        catch (e) {
            throw e;
        }
    }
    static async getPendingPointsForTicketEntries() {
        try {
            const requestUrl = `${GAME_PATH}/ticket-entries/points/pending/total`;
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserDrawsHistory(size, page) {
        let requestParams = ``;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        if (size) {
            requestParams = `size=${size}&` + requestParams;
        }
        const url = `${GAME_PATH}/draws/history?${requestParams}`;
        try {
            const response = await api_1.API.get({
                url,
                query: requestParams
            });
            return {
                data: history_1.HistoryDraw.JsonToDraws(response.content),
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getSecondChanceTicketHistory(drawId) {
        try {
            const requestUrl = `${GAME_PATH}/draws/history/${drawId} `;
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserPastActivityHistory(size, page) {
        let requestParams = ``;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        if (size) {
            requestParams = `size=${size}&` + requestParams;
        }
        const url = `${LEGACY_PATH}/activities?${requestParams}`;
        try {
            const response = await api_1.API.get({
                url,
                query: requestParams
            });
            return {
                data: response.content,
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getUserPastTicketsHistory(size, page) {
        let requestParams = ``;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        if (size) {
            requestParams = `size=${size}&` + requestParams;
        }
        const url = `${LEGACY_PATH}/tickets?${requestParams}`;
        try {
            const response = await api_1.API.get({
                url,
                query: requestParams
            });
            return {
                data: response.content,
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getEinstantBetHistoryGrouped(page, size) {
        try {
            const response = await api_1.API.get({
                url: `${EINSTANT_PATH}/transaction/consolidated`,
                query: {
                    size,
                    page
                }
            });
            if (response) {
                return {
                    data: history_1.HistoryEInstantGrouped.JsonToEInstantsGrouped(response.content),
                    page: {
                        last: response.last,
                        first: response.first,
                        totalElements: response.totalElements,
                        totalPages: response.totalPages,
                        number: response.number
                    }
                };
            }
            return {
                data: undefined,
                page: undefined
            };
        }
        catch (e) {
            throw e;
        }
    }
    static async getEinstantBetHistoryDetails(gameId, page, size) {
        try {
            const response = await api_1.API.get({
                url: `${EINSTANT_PATH}/transaction/game/${gameId}`,
                query: {
                    size,
                    page
                }
            });
            if (response) {
                return {
                    data: history_1.HistoryEInstant.JsonToEInstants(response.content),
                    page: {
                        last: response.last,
                        first: response.first,
                        totalElements: response.totalElements,
                        totalPages: response.totalPages,
                        number: response.number
                    }
                };
            }
            return {
                historyEInstants: undefined,
                activitiesLastPage: undefined
            };
        }
        catch (e) {
            throw e;
        }
    }
}
exports.HistoryService = HistoryService;
//# sourceMappingURL=history-service.js.map